import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
import(/* webpackMode: "eager" */ "/app/src/components/GrowthbookProvider/GrowthbookClientProvider.tsx")